import React, { createContext, useContext, useEffect, useState } from 'react';
import { TokenContext } from './TokenContext';
import axios from "@fetch/axios";
import { CartContext } from './CardContext';

export const LanguageCurrencyContext = createContext({
  lang: localStorage.getItem('lang_arteonu')!==null ?localStorage.getItem('lang_arteonu') :'es' ,
  currency: localStorage.getItem('currency_arteonu')!==null ? localStorage.getItem('currency_arteonu'):'mxn',
  cambiarLang: () => {},
  cambiarCurrency: () => {},
});

export const LanguageCurrencyProvider = ({ children }) => {

  const [lang, setLang] = useState(localStorage.getItem('lang_arteonu')!==null ?localStorage.getItem('lang_arteonu') :'es');
  const [currency, setCurrency] = useState(localStorage.getItem('currency_arteonu')!==null ? localStorage.getItem('currency_arteonu'):'mxn');
  const {getToken} =useContext(TokenContext);
  const {  setTotalPay } = useContext(CartContext);
  
  const cambiarLang = (newLang) => {
    setLang(newLang);
    if(newLang=='es'){
      cambiarCurrency('mxn')
    }else{
      cambiarCurrency('usd')
    }
    localStorage.setItem('lang_arteonu', newLang);
    countries(true)
  };

  const cambiarCurrency = async(newCurrency) => {
    setCurrency(newCurrency);
    localStorage.setItem('currency_arteonu', newCurrency);

    if(getToken() && localStorage.getItem('cartId')!==null && localStorage.getItem('cartId')!==''){

      const cart = await axios.put('/cart/currency', {
        cart_id: localStorage.getItem('cartId'),
        currency: newCurrency === 'usd' ? 'USD' : 'MXN'
      }, {
        headers: { 'Authorization': 'Bearer ' + getToken() }
      });

      if(cart.data){
        if(cart.data.products.length>0){
          localStorage.setItem('cart', JSON.stringify(cart.data.products));
        }
        setTotalPay(cart.data.total);
      }
    }

  };

  const countries = async(reload=false)=>{

    if (!localStorage.getItem('countries_arteonu') || reload) {
      try {
        const response = await axios.get(`/countries?lang=${localStorage.getItem('lang_arteonu')}`);
        localStorage.setItem('countries_arteonu', JSON.stringify(response.data));
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    }

  }

  useEffect(() => {

  
    // Verificar si el usuario accede con www. y redirigir sin www.
    if (window.location.hostname.startsWith('www.')) {
      const newUrl = window.location.protocol + '//' + 
                    window.location.hostname.replace(/^www\./, '') + 
                    window.location.pathname + 
                    window.location.search + 
                    window.location.hash;
      window.location.href = newUrl;
      return; // No ejecutar el resto del useEffect
    }

    const storedLang = localStorage.getItem('lang_arteonu');
    const storedCurrency = localStorage.getItem('currency_arteonu');
    
    if (storedLang !== null && storedLang !== '') {
      setLang(storedLang);
      countries(true)

    }else{
      cambiarLang('en')
    }
    
    if (storedCurrency !== null && storedCurrency !== '') {
      setCurrency(storedCurrency);
    }
  }, []);


  return (
    <LanguageCurrencyContext.Provider value={{ 
      lang, 
      currency, 
      cambiarLang, 
      cambiarCurrency 
      }}>
      {children}
    </LanguageCurrencyContext.Provider>
  );
};
